/** localStorage wrappers: every access may throw (private mode, blocked storage, quotas). */
export const DRAFT_KEY = 'frogless.playground.draft';
export const LANG_KEY = 'frogless.playground.lang';
export const TAB_KEY = 'frogless.playground.tab';
/** Id of the example the draft started from (scenario strip, replace confirmation). */
export const EXAMPLE_KEY = 'frogless.playground.example';
/** 'compact' (tabbed, dense) or 'notebook' (default). */
export const VIEW_KEY = 'frogless.playground.view';
/** '1' when the manuscript shows line numbers. */
export const LINE_NUMBERS_KEY = 'frogless.playground.lineNumbers';
/** '1' when the rows section shows the table instead of the bars. */
export const ROWS_TABLE_KEY = 'frogless.playground.rowsTable';
/** 'light' (default), 'dark' or 'system'; also read by the inline script in index.html before first paint. */
export const THEME_KEY = 'frogless.theme';

export function readStorage(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function writeStorage(key: string, value: string): boolean {
  try {
    window.localStorage.setItem(key, value);
    return true;
  } catch {
    return false;
  }
}

export function removeStorage(key: string): void {
  try {
    window.localStorage.removeItem(key);
  } catch {
    /* storage unavailable: nothing to remove */
  }
}
